<template>
  <div class="flex flex-col gap-4 py-4 w-full px-3">
    <h1 class="text-xl text-left font-bold border-b">Compensation</h1>
    <ErrorPage v-if="plan === 'basic' || plan === 'standard'" />
    <div v-else>
      <loader v-if="isloading" size="xxs" :loader-image="false" />
      <div v-else>
        <div v-if="jobClassification === 'jobCadre' && compensationModel === 'scaleBased' && orgType === 'public'">
          <ScaleBased />
        </div>
        <div v-else>
          <Card>
            <Tabs
              class="mt-2 mx-2"
              :tabs="tabsItems"
              :active-tab="activeTab"
              @currentTab="activeTab = $event"
              :border="true"
            />
          </Card>
          <div>
            <RangeSpread v-if="activeTab === 'Range Spread'" />
            <PayGrade v-if="activeTab === 'Pay Band'" />
            <Review v-if="activeTab === 'Review'" />
            <Preferences v-if="activeTab === 'Preferences'" />
            <PayScale v-if="activeTab === 'Pay Scale'" />
            <ScaleBased v-if="activeTab === 'Salary Scale'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorPage from "@/modules/Admin/error404";
import Tabs from "@scelloo/cloudenly-ui/src/components/tab"
import Card from "@scelloo/cloudenly-ui/src/components/card"

export default {

  components: {
    Tabs,
    Card,
    ErrorPage,
    PayGrade: () => import('./PayGrade'),
    Review: () => import('./Review'),
    RangeSpread: () => import('./RangeSpread'),
    Preferences: () => import('./Preferences'),
    PayScale: () => import('./PayScale'),
    ScaleBased: () => import('./ScaleBased'),
  },
  
  data() {
    return {
      activeTab: this.$route.query.activeTab || "Range Spread",
      tabs: ["Range Spread", "Pay Band", "Review", "Preferences"],
      jobClassification: "",
      compensationModel: "",
      orgType: "",
      isloading: true
    }
  },
  computed: {
    plan() {
      const result = this.$store.state.subscription ? this.$store.state.subscription.plan : null
      return result
    },
    tabsItems(){
      if(this.jobClassification === 'jobFamily' && 
        this.compensationModel === 'rangeBased'
      ){
        return this.tabs;
      }

      if(this.jobClassification === 'jobFamily' && 
        this.compensationModel === 'scaleBased'
      ){
        this.activeTab = "Pay Scale";
        this.tabs = ["Pay Scale", "Review", "Preferences"];
        return this.tabs;
      }

      if(this.jobClassification === 'jobCadre' && this.compensationModel === 'scaleBased' && this.orgType === 'private'){
        this.activeTab = "Salary Scale";
        this.tabs = ["Salary Scale", "Review", "Preferences"];
        return this.tabs
      }
    }
  },
  async created() {  
    const { data } = await this.$_getOrgProfile();
    console.log('data', data)
    this.jobClassification = data.org.jobClassification;
    this.compensationModel = data.org.compensationModel;
    this.orgType = data.org.orgType;
    this.isloading = false;
  },
};
</script>
